import { Box, Typography } from '@mui/material';
import { ReportsDataGrid } from './ReportsDataGrid';

export const ReportsList = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Investigation Reports
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <ReportsDataGrid />
      </Box>
    </Box>
  );
};
